import { v4 } from 'uuid';

/**
 * Generate a random id to use with maps and arrays in Firestore
 */
export const generateRandomId = () => {
  return v4();
};
